export const dummyTestimonials = [
  {
    id: 38,
    title: "Peace of Mind Achieved",
    description:
      "The preneed planner explained every step clearly and made our family feel secure about the future.",
    rating: 5,
    userId: 1,
    partnerId: 12,
    createdAt: "2025-11-14T10:52:25.565Z",
    user: {
      id: 1,
      email: "admin@example.com",
      first_name: "Admin",
      last_name: null,
    },
  },
  {
    id: 39,
    title: "Very Professional",
    description:
      "Handled our pre-arrangements with great care and provided detailed documentation.",
    rating: 4,
    userId: 2,
    partnerId: 12,
    createdAt: "2025-11-14T10:52:25.565Z",
    user: {
      id: 2,
      email: "aivioce@example.com",
      first_name: "AI Voice Agent",
      last_name: null,
    },
  },
  {
    id: 40,
    title: "Good, but Follow-up Could Be Better",
    description: "They were informative but took a while to respond to emails.",
    rating: 3,
    userId: 3,
    partnerId: 12,
    createdAt: "2025-11-14T10:52:25.565Z",
    user: {
      id: 3,
      email: "testuser1@example.com",
      first_name: "user1",
      last_name: null,
    },
  },
  {
    id: 41,
    title: "Could Use Improvement",
    description:
      "While the service was adequate, there were several areas that could be enhanced.",
    rating: 2,
    userId: 4,
    partnerId: 12,
    createdAt: "2025-11-14T10:52:25.565Z",
    user: {
      id: 4,
      email: "testuser2@example.com",
      first_name: "user2",
      last_name: null,
    },
  },
];
